<ng-container *transloco="let t; prefix: 'logout'">
    <div class="container py-5">
        <overlay-loading-spinner-border [show]="isLoading" />
        <div class="visually-hidden">{{ t("loadingtext") }}</div>
    </div>
</ng-container>